const translations = {
  selectChecklistTypes: 'Selección de tipo de cuestionario',
  type: 'Tipo',
  checklistType: 'Tipo de cuestionario'
}

export default translations
